// Generated from src/img/svg/switcher_schematic.svg

export const SwitcherSchematic = (props) => {
  return (
    <svg
      id="switcher_schematic_svg__Ebene_1"
      version="1.1"
      viewBox="0 0 50 50"
      x="0"
      xmlSpace="preserve"
      y="0"
      {...props}
    >
      <style>{".switcher_schematic_svg__st1{fill:#353535}"}</style>
      <path
        d="M44.8 21.8 36.4 27l-23.1-.2-8.1-5 1.1-3.2L25 8.6l19.8 11.1z"
        style={{ fill: "#cecece" }}
      />
      <path
        className="switcher_schematic_svg__st1"
        d="M24.9 19.5 36.4 27 25 34l-11.7-7.2z"
      />
      <path
        className="switcher_schematic_svg__st1"
        d="m48.5 19.5-3.7 2.3-2.8 1.7-17-11.1L7.6 23.3l-2.4-1.5-3.7-2.3L25 5zM48.5 30.5 25 45 1.5 30.5l4.8-2.9L25 39.1l18.7-11.5z"
      />
      <path d="M0 0h50v50H0z" style={{ fill: "none" }} />
    </svg>
  );
};
